import {
  useAppleMapkitWebExperiment,
  useExposeAppleMapkitWebExperiment,
} from 'experiments/use-enable-apple-mapkit-web-experiment';

import { IUseMapExtended, IUseMapExtendedParam } from './types';
import useAppleMap from './use-apple-map.web';
import useGoogleMap from './use-google-map.web';

/**
 * Extended map functionality (focusToPoints, getCurrentCenter, renderMarkers) for:
 * - Apple MapKit JS (Amplitude enable-apple-mapkit-web treatment)
 * - Google Maps JS (control / default)
 *
 * Waits for experiment readiness before initializing either provider.
 */
export const useMap: IUseMapExtended = (props: IUseMapExtendedParam) => {
  const { isReady, isTreatment, hasResolvedVariant } = useAppleMapkitWebExperiment();

  useExposeAppleMapkitWebExperiment(isReady && hasResolvedVariant);

  const enabledAppleMapkit = isReady && isTreatment;
  const enabledGoogleMaps = isReady && !isTreatment;

  const appleResult = useAppleMap(props, enabledAppleMapkit);
  const googleResult = useGoogleMap(props, enabledGoogleMaps);

  return enabledAppleMapkit ? appleResult : googleResult;
};
